module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "content"
    }
  }, [(_vm.user) ? _c('create-card-form', {
    attrs: {
      "user": _vm.user
    }
  }) : _vm._e(), _vm._v(" "), _c('cards', {
    attrs: {
      "user": _vm.user
    }
  }), _vm._v(" "), _c('update-modal'), _vm._v(" "), _c('stack-modal', {
    attrs: {
      "user": _vm.user
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-64c9efaa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Cards.vue
// module id = 201
// module chunks = 1